/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Saving_Vault_DataInputs */

const en_saving_vault_data = /** @type {(inputs: Saving_Vault_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving Vault Data...`)
};

const es_saving_vault_data = /** @type {(inputs: Saving_Vault_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardando datos de la bóveda...`)
};

const fr_saving_vault_data = /** @type {(inputs: Saving_Vault_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement des données du coffre-fort...`)
};

const de_saving_vault_data = /** @type {(inputs: Saving_Vault_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault-Daten werden gespeichert...`)
};

const ja_saving_vault_data = /** @type {(inputs: Saving_Vault_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保管庫のデータを保存中...`)
};

const zh_saving_vault_data = /** @type {(inputs: Saving_Vault_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在保存金库数据...`)
};

const ar_saving_vault_data = /** @type {(inputs: Saving_Vault_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاري حفظ بيانات الخزنة...`)
};

const id_saving_vault_data = /** @type {(inputs: Saving_Vault_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyimpan Data Vault...`)
};

const it_saving_vault_data = /** @type {(inputs: Saving_Vault_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvataggio dei Dati del Vault in corso...`)
};

const ru_saving_vault_data = /** @type {(inputs: Saving_Vault_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранение данных Хранилища...`)
};

const pt_saving_vault_data = /** @type {(inputs: Saving_Vault_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvando Dados do Cofre...`)
};

const ko_saving_vault_data = /** @type {(inputs: Saving_Vault_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보관소(Vault) 데이터 저장 중...`)
};

/**
* | output |
* | --- |
* | "Saving Vault Data..." |
*
* @param {Saving_Vault_DataInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const saving_vault_data = /** @type {((inputs?: Saving_Vault_DataInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Saving_Vault_DataInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_saving_vault_data(inputs)
	if (locale === "es") return es_saving_vault_data(inputs)
	if (locale === "fr") return fr_saving_vault_data(inputs)
	if (locale === "de") return de_saving_vault_data(inputs)
	if (locale === "ja") return ja_saving_vault_data(inputs)
	if (locale === "zh") return zh_saving_vault_data(inputs)
	if (locale === "ar") return ar_saving_vault_data(inputs)
	if (locale === "id") return id_saving_vault_data(inputs)
	if (locale === "it") return it_saving_vault_data(inputs)
	if (locale === "ru") return ru_saving_vault_data(inputs)
	if (locale === "pt") return pt_saving_vault_data(inputs)
	return ko_saving_vault_data(inputs)
});